import gsap from './gsap/gsap.min'

class Snow {

  constructor() {
    this._isMobile = !window.innerWidth > 500
    this._MAX_SNOWS = this._isMobile ? 100 : 200;
    this._MAX_SNOW_SIZE = 5;
    this._MAX_SNOW_SPEED = 3;
    this._isStatuspro = window.location.href.includes('statuspro')

    this._MIN_DATE = {
      month: 11,
      date: 1
    }
    this._MAX_DATE = {
      month: 0,
      date: 20
    }

    $(document).ready(this.documentReady());
  }

  documentReady() {
    const dateNow = new Date();

    if ((dateNow.getMonth() >= this._MIN_DATE.month && dateNow.getDate() >= this._MIN_DATE.date) || (dateNow.getMonth() <= this._MAX_DATE.month && dateNow.getDate() <= this._MAX_DATE.date))
      this.createSnows();
  }

  createSnows() {
    const container = this.createSnowContainer()
    for (let i = 0; i < this._MAX_SNOWS; i++) {

      const appendItem = this.getRandomItem(i);
      container.append(appendItem);

      const randomTime = Math.random() * this._MAX_SNOW_SPEED;
      this.goAnimate($(appendItem), i, randomTime);
      this.goAnimate2($(appendItem));
    }
  }

  goAnimate(item, id, randomTime) {
    gsap.to(item, {
      duration: randomTime, css: {marginTop: "+=100"}, ease: Linear.easeNone, onComplete: () => {

        const topPosition = item.css("margin-top").replace("px", "");

        if (topPosition > $(window).height()) {
          this.changePosition(item);
          randomTime = Math.random() * this._MAX_SNOW_SPEED;
          this.goAnimate(item, id, randomTime);
        } else {
          this.goAnimate(item, id, randomTime);
        }

      }
    });
  }

  goAnimate2(item) {

    const directionTime = 1 + Math.floor(Math.random() * 5);

    const randomDirection = 1 + Math.floor(Math.random() * 4);

    const delayTime = 1 + Math.floor(Math.random() * 3);

    if (randomDirection === 1) {

      gsap.to(item, directionTime, {
        css: {marginLeft: "+=100"}, ease: Linear.easeOut, onComplete: () => {

          gsap.to(item, directionTime, {
            css: {marginLeft: "-=100"}, delay: delayTime, ease: Linear.easeOut, onComplete: () => {
              this.goAnimate2(item);
            }
          });
        }
      });
    } else if (randomDirection === 2) {

      gsap.to(item, directionTime, {
        css: {marginLeft: "-=100"}, ease: Linear.easeOut, onComplete: () => {

          gsap.to(item, directionTime, {
            css: {marginLeft: "+=100"}, delay: delayTime, ease: Linear.easeOut, onComplete: () => {
              this.goAnimate2(item);
            }
          });
        }
      });
    } else if (randomDirection === 3) {

      gsap.to(item, directionTime, {
        css: {marginLeft: "+=100"}, ease: Linear.easeOut, onComplete: () => {
          this.goAnimate2(item);
        }
      });
    } else if (randomDirection === 4) {

      gsap.to(item, directionTime, {
        css: {marginLeft: "-=100"}, ease: Linear.easeOut, onComplete: () => {
          this.goAnimate2(item);
        }
      });
    }
  }

  changePosition(item) {
    const _width = Math.floor(Math.random() * this._MAX_SNOW_SIZE);
    const _height = _width;
    const _blur = Math.floor(Math.random() * 5 + 2);
    const _left = Math.floor(Math.random() * ($(window).width() - _width));
    const _top = -$(window).height() + Math.floor(Math.random() * ($(window).height() - _height));

    item.css("width", _width);
    item.css("height", _height);
    item.css("margin-left", _left);
    item.css("margin-top", _top);
    item.css("-webkit-filter", "blur(" + String(_blur) + "px)");
    item.css("-moz-filter", "blur(" + String(_blur) + "px)");
    item.css("-o-filter", "blur(" + String(_blur) + "px)");
    item.css("-ms-filter", "blur(" + String(_blur) + "px)");
    item.css("filter", "blur(" + String(_blur) + "px)");
  }

  getRandomItem(id) {
    const _width = Math.floor(Math.random() * this._MAX_SNOW_SIZE);
    const _height = _width;
    const _blur = Math.floor(Math.random() * 5 + 2);
    const _left = Math.floor(Math.random() * ($(window).width() - _width));
    const _top = -$(window).height() + Math.floor(Math.random() * ($(window).height() - _height));
    const _id = id;

    return this.getSmallSnow(_width, _height, _blur, _left, _top, _id);
  }

  createSnowContainer() {
    const snowContainer = document.createElement('div');
    snowContainer.style.position = 'fixed';
    snowContainer.style.width = '100%';
    // snowContainer.style.height = '100%';
    // snowContainer.style.overflow = 'hidden';
    snowContainer.style.zIndex = '91';
    document.body.prepend(snowContainer);
    return snowContainer
  }

  getSmallSnow(width, height, blur, left, top, id) {
    const item = document.createElement('div');
    item.classList.add(`snow${id}`);
    item.classList.add(`snow-color`);
    item.style.position = 'fixed';
    item.style.marginLeft = `${left}px`;
    item.style.marginTop = `${top}px`;
    item.style.width = `${width}px`;
    item.style.height = `${height}px`;
    item.style.borderRadius = '50%';
    item.style.backgroundColor = this._isStatuspro ? '#008fff' : '#fff'
    // item.style.backgroundColor = '#fff'

    item.style.webkitFilter = `blur(${blur}px)`;
    item.style.mozFilter = `blur(${blur}px)`;
    item.style.oFilter = `blur(${blur}px)`;
    item.style.msFilter = `blur(${blur}px)`;
    item.style.filter = `blur(${blur}px)`;
    return item
  }

  addBonnyForLesha() {
    const bunnyContainer = document.createElement('div');
    // bunnyContainer.style.width = '100%'
    // bunnyContainer.style.height = '100%'
    bunnyContainer.style.position = 'absolute'
    // bunnyContainer.style.backgroundColor = '#37b5a9'

    // bunnyContainer.style.display = 'flex'
    // bunnyContainer.style.alignItems = 'center'
    // bunnyContainer.style.justifyContent = 'center'
    bunnyContainer.style.zIndex = '90'

    const bunny = document.createElement('img');


    bunny.src = '/themes/jurist/assets/img/bunny.gif'
    bunnyContainer.append(bunny)

    document.body.prepend(bunnyContainer);
  }
}

export default new Snow();
